import { useMemo, useRef } from 'react'
import { useQuery } from 'react-query'
import { categoriesQueryData, CategoriesResponse } from 'src/api'
import { Category } from 'src/types/entities'
import { mapBackendCategories } from 'src/utils'

type FetchCategoriesResult = {
  categoriesError: unknown,
  isCategoriesFetching: boolean,
  categories: Category[] | undefined,
}

const useFetchCategories = (): FetchCategoriesResult => {
  const {
    error: categoriesError,
    data: categoriesResponse,
    isLoading: isCategoriesFetching,
  } = useQuery<CategoriesResponse>(
    categoriesQueryData.key,
    categoriesQueryData.fetch,
  )
  const mappingError = useRef<null | unknown>(null)

  const categories = useMemo(() => {
    try {
      const backendCategories = categoriesResponse?.categories

      return backendCategories && mapBackendCategories(backendCategories)
    } catch (e) {
      mappingError.current = e

      return []
    }
  }, [categoriesResponse])

  return {
    categoriesError: mappingError.current || categoriesError,
    isCategoriesFetching,
    categories,
  }
}

export { useFetchCategories }
export type { FetchCategoriesResult }
